import { css } from 'emotion';

const body = css`
  padding: 10px 0px 20px;
  display: flex;
  align-items: center;
  gap: 13px;

  & > :first-child {
    margin-left: 30px;
  }
`;

const alignItems = css`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export default {
  body,
  alignItems,
};
